import { useEffect, useState } from "react";
import { getFromApi, putToApi, deleteFromApi } from "../api/auth";

export default function Admin() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchUsers = () => {
        getFromApi("api/admin/users")
            .then(res => setUsers(res.data || []))
            .catch(() => {})
            .finally(() => setLoading(false));
    };

    useEffect(() => { fetchUsers(); }, []);

    const toggleRole = async (user) => {
        const newRole = user.role.includes("admin")
            ? user.role.filter(r => r !== "admin")
            : [...user.role, "admin"];
        if (newRole.length === 0) newRole.push("user");
        await putToApi(`api/admin/users/${user._id}/role`, { role: newRole });
        fetchUsers();
    };

    const deleteUser = async (user) => {
        if (!window.confirm(`Delete ${user.email}?`)) return;
        await deleteFromApi(`api/admin/users/${user._id}`);
        fetchUsers();
    };

    return (
        <div>
            <div className="page-header">
                <h4>Admin — Users</h4>
            </div>

            <div className="panel p-0">
                {loading ? (
                    <div className="text-muted small p-3">Loading...</div>
                ) : (
                    <div className="table-wrap">
                    <table className="table table-sm mb-0">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Joined</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(u => (
                                <tr key={u._id}>
                                    <td className="align-middle">{u.email}</td>
                                    <td className="align-middle">
                                        {u.role.includes("admin") ? (
                                            <span className="badge bg-primary">admin</span>
                                        ) : (
                                            <span className="badge bg-secondary">user</span>
                                        )}
                                    </td>
                                    <td className="align-middle small text-muted">
                                        {u.created_on ? new Date(u.created_on).toLocaleDateString() : "—"}
                                    </td>
                                    <td className="align-middle text-end">
                                        <button
                                            className="btn btn-sm btn-outline-secondary me-2"
                                            onClick={() => toggleRole(u)}
                                        >
                                            {u.role.includes("admin") ? "Remove admin" : "Make admin"}
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => deleteUser(u)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                )}
            </div>
        </div>
    );
}
